export { component } from './component';
export { dom } from './dom';
